export default __webpack_public_path__ + "static/media/image_4.7423a3e0.jpg";